var SyntheticEvent = /** @class */ (function () {
    function SyntheticEvent(type, params) {
        this.type = type;
        this.original = params.original;
        this.bubbles = params.bubbles;
        this.timeStamp = params.timeStamp || Date.now();
    }
    SyntheticEvent.prototype.preventDefault = function () {
        if (this.original.preventDefault) {
            this.original.preventDefault();
        }
    };
    SyntheticEvent.prototype.stopPropagation = function () {
        this.isPropagationStopped = true;
    };
    return SyntheticEvent;
}());
export default SyntheticEvent;
